import { render, staticRenderFns } from "./CustomerManagementIPAddress.vue?vue&type=template&id=2db292c6&scoped=true&"
import script from "./CustomerManagementIPAddress.vue?vue&type=script&lang=js&"
export * from "./CustomerManagementIPAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db292c6",
  null
  
)

export default component.exports